export default [
  {
    path: '/member/index',
    name: 'memberindex',
    meta: {
      title: '会员中心'
    },
    component: () => import('@/views/member/userindex.vue')
  },
  {
    path: '/member/order/:id',
    name: 'memberorder',
    meta: {
      title: '我的订单'
    },
    component: () => import('@/views/member/ordercenter/orderlist.vue')
  }, {
    path: '/member/backapply/:id',
    name: 'backapply',
    meta: {
      title: '售后申请'
    },
    component: () => import('@/views/member/service/productbackapply.vue')
  }, {
    path: '/member/productbackapply',
    name: 'productbackapply',
    meta: {
      title: '售后申请'
    },
    component: () => import('@/views/member/service/productbackapplyinput.vue')
  }, {
    path: '/member/backDeliverGoods/:id',
    name: 'backdelivergoods',
    meta: {
      title: '用户退货发货'
    },
    component: () => import('@/views/member/service/backdelivergoods.vue')
  }, {
    path: '/member/exchangeDeliverGoods/:id',
    name: 'exchangedelivergoods',
    meta: {
      title: '用户换货发货'
    },
    component: () => import('@/views/member/service/exchangedelivergoods.vue')
  },{
    path: '/member/detail/:id',
    name: 'orderdetail',
    meta: {
      title: '订单详情'
    },
    component: () => import('@/views/member/ordercenter/orderdetail.vue')
  }, {
    path: '/member/question',
    name: 'myconsultation',
    meta: {
      title: '我的咨询'
    },
    component: () => import('@/views/member/ordercenter/myconsultation.vue')
  }, {
    path: '/member/comment',
    name: 'myevaluation',
    meta: {
      title: '我的评价'
    },
    component: () => import('@/views/member/ordercenter/myevaluation.vue')
  }, {
    path: '/member/addcomment/:id',
    name: 'addcomment',
    meta: {
      title: '添加评价'
    },
    component: () => import('@/views/member/ordercenter/addevaluation.vue')
  }, {
    path: '/member/coupon-use',
    name: 'couponuser',
    meta: {
      title: '我的优惠券'
    },
    component: () => import('@/views/member/ordercenter/couponuser.vue')
  }, {
    path: '/member/couponuser-yes',
    name: 'couponuser-yes',
    meta: {
      title: '我的优惠券'
    },
    component: () => import('@/views/member/ordercenter/couponuseryes.vue')
  }, {
    path: '/member/collectproduct',
    name: 'collectiongoods',
    meta: {
      title: '收藏商品'
    },
    component: () => import('@/views/member/collection/collectiongoods.vue')
  }, {
    path: '/member/collectshop',
    name: 'collectionshop',
    meta: {
      title: '收藏店铺'
    },
    component: () => import('@/views/member/collection/collectionshop.vue')
  }, {
    path: '/member/viewed',
    name: 'productlooklog',
    meta: {
      title: '浏览记录'
    },
    component: () => import('@/views/member/collection/productlooklog.vue')
  }, {
    path: '/member/back',
    name: 'productbacklist',
    meta: {
      title: '我的退货'
    },
    component: () => import('@/views/member/service/productbacklist.vue')
  }, {
    path: '/member/backdetail/:id/:pid/:oid',
    name: 'productbacklist',
    meta: {
      title: '退货申请查看'
    },
    component: () => import('@/views/member/service/productbackdetail.vue')
  }, {
    path: '/member/addbackcomplain/:id/:pid/:oid/:sid',
    name: 'complainapply',
    meta: {
      title: '退货投诉申请'
    },
    component: () => import('@/views/member/service/complainapply.vue')
  }, {
    path: '/member/addchangecomplain/:id/:pid/:oid/:sid',
    name: 'complainchangeapply',
    meta: {
      title: '换货投诉申请'
    },
    component: () => import('@/views/member/service/complainchangeapply.vue')
  }, {
    path: '/member/exchange',
    name: 'productexchangelist',
    meta: {
      title: '我的换货'
    },
    component: () => import('@/views/member/service/productexchangelist.vue')
  }, {
    path: '/member/exchangedetail/:id/:pid/:oid',
    name: 'productExchangedetail',
    meta: {
      title: '换货申请'
    },
    component: () => import('@/views/member/service/productExchangedetail.vue')
  }, {
    path: '/member/withdraw',
    name: 'withdrawdepositlist',
    meta: {
      title: '提现申请'
    },
    component: () => import('@/views/member/service/withdrawdepositlist.vue')
  }, {
    path: '/member/withdrawdetail/:id',
    name: 'withdrawdepositdetail',
    meta: {
      title: '提现申请查看页面'
    },
    component: () => import('@/views/member/service/withdrawdepositdetail.vue')
  }, {
    path: '/member/withdrawapply',
    name: 'withdrawdepositapply',
    meta: {
      title: '提现申请'
    },
    component: () => import('@/views/member/service/withdrawdepositapply.vue')
  }, {
    path: '/member/balance',
    name: 'balancelist',
    meta: {
      title: '账户余额'
    },
    component: () => import('@/views/member/service/balancelist.vue')
  }, {
    path: '/member/addbalancepassword',
    name: 'balancepwdadd',
    meta: {
      title: '设置支付密码'
    },
    component: () => import('@/views/member/service/balancepwdadd.vue')
  }, {
    path: '/member/editbalancepassword',
    name: 'balancepwdedit',
    meta: {
      title: '修改支付密码'
    },
    component: () => import('@/views/member/service/balancepwdedit.vue')
  }, {
    path: '/member/balancepwdreset',
    name: 'balancepwdreset',
    meta: {
      title: '重置支付密码'
    },
    component: () => import('@/views/member/service/balancepwdreset.vue')
  }, {
    path: '/member/complain',
    name: 'complainlist',
    meta: {
      title: '我的投诉'
    },
    component: () => import('@/views/member/service/complainlist.vue')
  }, {
    path: '/member/complaindetail/:pid/:id/:infoid',
    name: 'complainapplydetail',
    meta: {
      title: '投诉信息查看'
    },
    component: () => import('@/views/member/service/complainapplydetail.vue')
  },
  {
    path: '/member/sale/salefinanceinfo',
    name: 'salefinanceinfo',
    meta: {
      title: '财物信息'
    },
    component: () => import('@/views/member/sale/salefinanceinfo.vue')
  }, {
    path: '/member/info',
    name: 'personalfile',
    meta: {
      title: '个人资料'
    },
    component: () => import('@/views/member/account/personalfile.vue')
  }, {
    path: '/member/integral',
    name: 'integrallist',
    meta: {
      title: '积分账户'
    },
    component: () => import('@/views/member/account/integrallist.vue')
  }, {
    path: '/member/grade',
    name: 'gradelist',
    meta: {
      title: '经验值'
    },
    component: () => import('@/views/member/account/gradelist.vue')
  }, {
    path: '/member/address',
    name: 'myreciptaddress',
    meta: {
      title: '收货地址'
    },
    component: () => import('@/views/member/account/myreciptaddress.vue')
  },
  {
    path: '/member/sale/saleindex',
    name: 'saleindex',
    meta: {
      title: '我的推广码'
    },
    component: () => import('@/views/member/sale/saleindex.vue')
  },
  {
    path: '/saleEnter',
    name: 'saleEnter',
    meta: {
      title: '我的推广码'
    },
    component: () => import('@/views/member/sale/sale_enter.vue')
  },
  {
    path: '/member/sale/saleMessage',
    name: 'saleindex',
    meta: {
      title: '我的推广码'
    },
    component: () => import('@/views/member/sale/saleMessage.vue')
  },
  {
    path: '/member/sale/saleWithdrawal',
    name: 'saleWithdrawal',
    meta: {
      title: '我的提现'
    },
    component: () => import('@/views/member/sale/saleWithdrawal.vue')
  },
  {
    path: '/member/sale/salefinanceinfo',
    name: 'salefinanceinfo',
    meta: {
      title: '财务信息'
    },
    component: () => import('@/views/member/sale/salefinanceinfo.vue')

  },
  {
    path: '/member/sale/saleapplymoney',
    name: 'saleapplymoney',
    meta: {
      title: '结算中心'
    },
    component: () => import('@/views/member/sale/saleapplymoney.vue')
  },
  {
    path: '/member/sale/saleorder',
    name: 'saleorder',
    meta: {
      title: '收入流水'
    },
    component: () => import('@/views/member/sale/saleorder.vue')
  },
  {
    path: '/member/sale/salemember1',
    name: 'salemember1',
    meta: {
      title: '我的推广用户'
    },
    component: () => import('@/views/member/sale/salemember1.vue')
  },
  {
    path: '/member/sale/salemember2',
    name: 'salemember2',
    meta: {
      title: '我的间接推广用户'
    },
    component: () => import('@/views/member/sale/salemember2.vue')
  },
  {
    path: '/member/recharge',
    name: 'recharge',
    meta: {
      title: '充值'
    },
    component: () => import('@/views/member/balancepay/recharge.vue')
  },
  {
    path: '/member/balance/pay/selectpay',
    name: 'selectpay',
    meta: {
      title: '在线支付'
    },
    component: () => import('@/views/member/balancepay/selectpay.vue')
  },
  {
    path: '/member/balance/pay/weixinpay',
    name: 'selectpay',
    meta: {
      title: '微信支付'
    },
    component: () => import('@/views/member/balancepay/weixinpay.vue')
  },
  {
    path: '/member/sale/saleorderdetail',
    name: 'saleorderdetail',
    meta: {
      title: '收入流水'
    },
    component: () => import('@/views/member/sale/saleorderdetail.vue')

  },
  {
    path: '/inquiry/index',
    name: 'inquiryIndex',
    meta: {
      title: '我的询价'
    },
    component: () => import('@/views/member/inquiry/index.vue')
  },
  {
    path: '/inquiry/details',
    name: 'inquiryDetail',
    meta: {
      title: '我的询价详情'
    },
    component: () => import('@/views/member/inquiry/details.vue')
  },
  {
    path: '/inquiry/chooseList',
    name: 'inquiryChooseList',
    meta: {
      title: '已选订单'
    },
    component: () => import('@/views/member/inquiry/chooseList.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/member.js